import axios from 'axios';
import Cookies from 'universal-cookie';

const getAuthCookie = () => {
  const cookies = new Cookies();
  return cookies.get('access-token');
};

const buildAuthorizationHeader = () => {
  let authToken = getAuthCookie();
  let headers = {
    Authorization: 'Bearer ' + authToken,
  };

  return headers;
};

const buildOptionalHeader = (optionalHeaders) =>{
  const authorizationHeader = buildAuthorizationHeader();
  return {...authorizationHeader,...optionalHeaders};
};

const buildConfigurations = (optionalHeaders, otherConfigurations) => ({headers:buildOptionalHeader(optionalHeaders), ...otherConfigurations});

const secureGet = (url, { params } = {}, optionalHeaders={}, otherConfigurations={}) => (
    axios.get(url, { params, ...buildConfigurations(optionalHeaders, otherConfigurations) })
);

const securePost = (url, data = {},  optionalHeaders={}, otherConfigurations={}) => (
    axios.post(url, data, buildConfigurations(optionalHeaders, otherConfigurations))
);

const securePut = (url, data = {}, optionalHeaders={}, otherConfigurations={}) => (
    axios.put(url, data, buildConfigurations(optionalHeaders, otherConfigurations))
);

const secureDelete = (url, { data } = {}, optionalHeaders={}, otherConfigurations={}) => (
    axios.delete(url, { data, ...buildConfigurations(optionalHeaders, otherConfigurations)})
);

const securePatch = (url, data = {}, optionalHeaders={}, otherConfigurations={}) => (
  axios.patch(url, data, buildConfigurations(optionalHeaders, otherConfigurations))
);

export { secureGet, securePost, securePut, secureDelete, securePatch, getAuthCookie };